import convertDayIndexingToSatSunFormat from './convertDayIndexingToSatSunFormat';

export default function getDaysListForMonth(date: Date) {
  const configDate = new Date(date);
  const year = configDate.getFullYear();
  const month = configDate.getMonth();
  const firstDate = new Date(year, month, 1);
  const totalDays = new Date(year, month + 1, 0).getDate();
  const offset = convertDayIndexingToSatSunFormat(firstDate);
  return [...Array(totalDays + offset)].map((_, index) => {
    const dateValue = index + 1 - offset;
    if (dateValue < 1) return null;
    return dateValue;
  });
}
